(function ($) {
    // Run JS Functions in Gutenberg Editor
    var initializeBlock = function ($block) {
        featureProductSliderSetup();
    }

    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=feature-product-category-slider', initializeBlock);
    }
})(jQuery);